import React, { Component } from 'react';
import { connect } from 'react-redux';
import { choseBankIndex,choseCurrentIndex ,choseBankOrCurrent} from '../../../action/productAction';
import Util from '../../../util';
import { hashHistory } from 'react-router';
import NavigatorMain from '../../NavigatorMain';
import {bankCode} from '../../../BankCode';
import store from '../../../ReduxStore.js';
import { hqtXz } from "../../../action/investmentAction"
import {
  getPayAll,
  goLogin
} from '../../../getPay';
// import { findCamcHqtExist } from '../../../action/myAssets/userInfoAction'
import { getCardList } from '../../../action/myAssets/myCardAction'
import { getTempInfo } from '../../../common.js';
class PayCard extends Component {
  constructor(props) {
    super(props);
    this.state = {

  
    };
  }
  componentWillMount() {
  }
  toGetCardList = async () => {
    let params = {
      token: await getTempInfo('shortToken'),
    }
    store.dispatch(getCardList(params, (content)=>{ console.log(content) }, (msg)=> { console.log(msg) } ))
  }
  componentDidMount(){
    // let data = store.getState().verifiedUserInfo.content;
    // console.log(data)
    // let inParamsData = {
    //   certNo: data.certNo,
    //   certType: data.certType,
    //   name: data.name
    // }
    // store.dispatch(findCamcHqtExist(inParamsData))
    this.toGetCardList();
  }
  choseBank(){
    hashHistory.push({
      pathname: '/PayCardList',
      state:{
        type:this.props.type,
        actionType:this.props.actionType,
        fundCode:this.props.superFundCode
      }
    });
  }
  renderRecharge(){
    let {payInfoData}=this.props;
    if (payInfoData.currentType==2)
      return(
        <div style={{height:46.5, display: "-webkit-flex", WebkitFlexDirection: "row", WebkitAlignItems: "center", borderTopColor: "#EBEBEB", borderTopWidth: 0.5, borderTopStyle: "solid"}}>
          {
            payInfoData.currentType == 2 ?
            <div style={{display: "-webkit-flex", WebkitFlexDirection: "row", WebkitAlignItems: "center"}} onClick={()=>this.goHQT(payInfoData.content.shareList[payInfoData.currentIndex])}>
              <span style={{fontSize:12,color:'#999'}}>可用余额不足？</span>
              <span style={{fontSize:12,color:'#B69271',fontWeight: "500"}}>立即充值</span>
            </div>
            :
            <div style={{display: "flex", WebkitFlexDirection: "row", WebkitAlignItems: "center"}}  onClick={()=>this.goLQB(payInfoData.content.currencyFund[payInfoData.currentIndex])}>
              <span style={{fontSize:12,color:'#999'}}>可用余额不足？</span>
              <span style={{fontSize:12,color:'#B69271',fontWeight: "500"}}>立即充值</span>
            </div>
          }
        </div>
      )
    else 
      return (
        <div></div>
      )
  }
  goHQT(parmas){
    let { navigator ,dispatch,fundCode} = this.props;
    let data={
      fundCode:'003003',
      businessType:'T022',
      productType:'G',
      type:this.props.type,
      bankAccountShowNo:parmas.bankAccountShowNo,
      currentIndex:this.props.payInfoData.currentIndex
    }
    this.props.dispatch(hqtXz(parmas.bankCode))
    getPayAll( window.history.length, data, hashHistory, 'RechargeHqt')
  }
  render(){
    const { 
      payInfoData
    }=this.props;
    console.log(payInfoData,"66666666666");
    return (
        <div>
          {
            payInfoData.currentType==1&&payInfoData.content.yhkNewListList.length>0?payInfoData.content.yhkNewListList.map( (item,i)=> {
              if (i==payInfoData.currentIndex) {
                if (item.disable) {
                  return (
                    <div key={`yhkNewListList${i}`} onClick={()=>this.choseBank()}>
                      <div style={{paddingTop: 15,paddingBottom: 15, display: "-webkit-flex", WebkitFlexDirection: "row",WebkitJustifyContent:"space-between", WebkitAlignItems: "center"}}>
                        <div style={{width:100}}>
                          <span style={{color:'#333',fontSize:16, fontWeight: "500"}}>支付方式</span>
                        </div>
                        <div style={{display: "-webkit-flex", WebkitFlexDirection: "row", WebkitAlignItems: "center"}}>
                          <div style={{display: "-webkit-flex", WebkitFlexDirection: "column", WebkitAlignItems: "flex-end"}}>
                            {
                              item.paymentChannel == '888' ? 
                              <div style={{display: "-webkit-flex", WebkitFlexDirection: "row", WebkitAlignItems: "center"}}>
                                <img style={{height:14,width:14}} src={ require('../../../img/bank.png')} />
                                <span style={{color:'#333',fontSize:14, marginLeft: 3}}>理财中心</span>
                              </div>
                              :
                              <div style={{display: "-webkit-flex", WebkitFlexDirection: "row", WebkitAlignItems: "center"}}>
                                <img style={{height:14,width:14}} src={ bankCode['ty'][item.bankCode]?bankCode['ty'][item.bankCode]:require('../../../img/bank.png')} />
                                <span style={{color:'#333',fontSize:14, marginLeft: 3}}>{(item.yhkBool?"直销银行卡-":"财富银行卡-")+Util.formatStr(item.bankName)+'(尾号'+Util.formatStr(item.bankAccountShowNo).substr(-4)+')'}</span>
                              </div>
                            }
                            {
                              item.paymentChannel == '888' ? 
                              <div style={{WebkitFlexDirection: "row", WebkitAlignItems: "center", display: "-webkit-flex", marginTop: 3}}>
                                <span style={{color:'#999',fontSize:12, marginLeft: 3}}>理财中心POS机刷卡</span>
                              </div>
                              :
                              <div style={{WebkitFlexDirection: "row", WebkitAlignItems: "center", display: "-webkit-flex", marginTop: 3}}>
                                <span style={{color:'#999',fontSize:12, marginLeft: 3}}>{item.yhkBool ? window.funSplit(item.tradeMaxAmountTips)[0]>=999999999999 ? '单笔无限额，单日无限额' : item.paymentChannelId=='G000' && item.bankCode=='007' ? '单笔限额20万，单日限额20万' : item.dayMonthLimit && window.funSplit(item.tradeMaxAmountTips)[0] ? "单笔限额"+window.funSplit(item.tradeMaxAmountTips)[0]/10000+"万"+item.dayMonthLimit : window.funSplit(item.tradeMaxAmountTips)[0] ? "单笔限额"+window.funSplit(item.tradeMaxAmountTips)[0]/10000+"万" : '' : window.funSplit(item.tradeMaxAmountTips)[1]}</span>
                              </div>
                            }
                          </div>
                          <img style={{height:10,width:10}} src={require('../../../imgs/pay_you_allow.png')} />
                        </div>
                      </div>
                    </div>
                  )
                }else{
                  return(
                    <div key={`yhkNewListList${i}`} onClick={()=>this.choseBank()}>
                      <div style={{paddingTop: 15,paddingBottom: 15, WebkitFlexDirection: "row",WebkitJustifyContent:"space-between", WebkitAlignItems: "center",display: "-webkit-flex"}}>
                        <span style={{color:'#333',fontSize:16, fontWeight: "500"}}>支付方式</span>
                        <span style={{color:'#333',fontSize:16, fontWeight: "500"}}>无支付方式</span>
                      </div>
                    </div>
                  )
                }
              } 
            }):payInfoData.currentType==2&&payInfoData.content.shareList.length>0?payInfoData.content.shareList.map( (item,i)=> {
              if (i==payInfoData.currentIndex) {
                if (item.disable) {
                  return (
                    <div key={`shareList${i}`} onClick={()=>this.choseBank()}>
                      <div style={{paddingTop: 15,paddingBottom: 15, display: "-webkit-flex", WebkitFlexDirection: "row",WebkitJustifyContent:"space-between", WebkitAlignItems: "center"}}>
                        <div>
                          <span style={{color:'#333',fontSize:16, fontWeight: "500"}}>支付方式</span>
                        </div>
                        <div style={{display: "-webkit-flex", WebkitFlexDirection: "row", WebkitAlignItems: "center"}}>
                          <div style={{display: "-webkit-flex", WebkitFlexDirection: "column", WebkitAlignItems: "flex-end"}}>
                            {
                              item.paymentChannel == '888' ? 
                              <div style={{display: "-webkit-flex", WebkitFlexDirection: "row", WebkitAlignItems: "center"}}>
                                <img style={{height:14,width:14}} src={ require('../../../img/bank.png')} />
                                <span style={{color:'#333',fontSize:14, marginLeft: 3}}>活期通{'('+ Util.formatStr(item.trustChannelName) + '尾号'+Util.formatStr(item.bankAccountShowNo).substr(-4)+')'}</span>
                              </div>
                              :
                              <div style={{display: "-webkit-flex", WebkitFlexDirection: "row", WebkitAlignItems: "center"}}>
                                <img style={{height:14,width:14}} src={ bankCode['ty'][item.bankCode]?bankCode['ty'][item.bankCode]:require('../../../img/bank.png')} />
                                <span style={{color:'#333',fontSize:14, marginLeft: 3}}>{`${typeof(item.trustChannelName)=='string'?item.trustChannelName.indexOf('-')>-1?item.trustChannelName.split('-')[0]:'--':'--'}`}{`(${typeof(item.trustChannelName)=='string'?item.trustChannelName.indexOf('-')>-1?item.trustChannelName.split('-')[1]:'--':'--'}尾号${Util.formatStr(item.bankAccountShowNo).substr(-4)})`}</span>
                              </div>
                            }
                            {
                              item.paymentChannel == "G000" && item.ywt == false ?
                              <div style={{WebkitFlexDirection: "row", WebkitAlignItems: "center", display: "-webkit-flex", marginTop: 3, width: 200, WebkitFlexWrap: "wrap"}}>
                                <span style={{color:'#999',fontSize:12, marginLeft: 3}}>招行卡暂不可用，请您去华夏基金管家App操作或咨询客服</span>
                              </div>
                              :
                              <div style={{WebkitFlexDirection: "row", WebkitAlignItems: "center", display: "-webkit-flex", marginTop: 3}}>
                                <span style={{color:'#999',fontSize:12, marginLeft: 3}}>可用余额：</span>
                                <span style={{color:'#B69271',fontSize:12, fontWeight: "500",}}>{Util.newToFixed(item.availableVolume)}元</span>
                              </div>
                            }
                          </div>
                          <img style={{height:10,width:10}} src={require('../../../imgs/pay_you_allow.png')} />
                        </div>
                      </div>
                    </div>
                  )
                }else{
                  return(
                    <div key={`shareList${i}`} onClick={()=>this.choseBank()}>
                      <div style={{paddingTop: 15,paddingBottom: 15, WebkitFlexDirection: "row",WebkitJustifyContent:"space-between", WebkitAlignItems: "center",display: "-webkit-flex"}}>
                        <span style={{color:'#333',fontSize:16, fontWeight: "500"}}>支付方式</span>
                        <span style={{color:'#333',fontSize:16, fontWeight: "500"}}>无支付方式</span>
                      </div>
                    </div>
                  )
                }
              } 
            }):payInfoData.currentType==3&&payInfoData.content.currencyFund.length>0?payInfoData.content.currencyFund.map( (item,i)=> {
              if (i==payInfoData.currentIndex) {
                return(
                  <div key={`currencyFund${i}`} onClick={()=>this.choseBank()}>
                    <div style={{paddingTop: 15,paddingBottom: 15, WebkitFlexDirection: "row",WebkitJustifyContent:"space-between", WebkitAlignItems: "center", display: "-webkit-flex"}}>
                      <div>
                        <span style={{color:'#333',fontSize:16, fontWeight: "500"}}>支付方式</span>
                      </div>
                      <div style={{display: "-webkit-flex", WebkitFlexDirection: "row", WebkitAlignItems: "center"}}>
                        <div style={{display: "-webkit-flex", WebkitFlexDirection: "column", WebkitAlignItems: "flex-end"}}>
                          <div style={{display: "-webkit-flex", WebkitFlexDirection: "row", WebkitAlignItems: "center"}}>
                            <img style={{width:14,height:14}} src={ require('../../../img/icon_LQB.png')} />
                            <span style={{color:'#333',fontSize:14, marginLeft: 3}}>{item.fundName}</span>
                          </div>
                          <div style={{display: "-webkit-flex", WebkitFlexDirection: "row", WebkitAlignItems: "center", marginTop: 3}}>
                            <span style={{color:'#333',fontSize:14, marginLeft: 3}}>{'('+Util.formatStr(item.trustChannelName)+'尾号'+Util.formatStr(item.bankAccountShowNo).substr(-4)+')'}</span>
                          </div>
                          <div style={{WebkitFlexDirection: "row", WebkitAlignItems: "center", display: "-webkit-flex", marginTop: 3}}>
                            <span style={{color:'#999',fontSize:12, marginLeft: 3}}>可用余额：</span>
                            <span style={{color:'#B69271',fontSize:12, fontWeight: "500",}}>{Util.newToFixed(item.availableVolume)}元</span>
                          </div>
                        </div>
                        <img style={{height:10,width:10}} src={require('../../../imgs/pay_you_allow.png')} />
                      </div>
                    </div>
                  </div>
                )
              } 
            }):
            <div key={`currencyFund$ff`} onClick={()=>this.choseBank()}>
              <div style={{paddingTop: 15,paddingBottom: 15, WebkitFlexDirection: "row",WebkitJustifyContent:"space-between", WebkitAlignItems: "center",display: "-webkit-flex"}}>
                <span style={{color:'#333',fontSize:16, fontWeight: "500"}}>支付方式</span>
                <span style={{color:'#333',fontSize:16, fontWeight: "500"}}>无支付方式</span>
              </div>
            </div>
            }
            {
              this.renderRecharge()
            }
        </div>
    );
  }
}


function mapStateToProps(state, ownProps) {
  console.log(state,ownProps);
  return {
    payInfoData:state[ownProps.type+'PayInfo']

  }
}
export default connect(mapStateToProps)(PayCard);



// WEBPACK FOOTER //
// ./src/components/myAssets/payment/PayCardSuperFund.js